import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import Styles from '@widgets/shared/components/Notice/styles';
import { useContext, useState } from 'react';
import { OptionsCTX } from '@widgets/AccountPage/types/Options';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import API from '@widgets/shared/API/connection';
import { useAppDispatch } from '@widgets/AccountPage/store/hooks';
import { setActiveBookings, setPastBookings } from '@widgets/AccountPage/store/reducers/bookings';
import FormNotices from '@widgets/shared/components/FormNotices';
import { Actions, Copy, NoticeWrapper, Title, Wrapper, } from './styles';
const cancelBooking = AwesomeDebouncePromise(API.cancelBooking, 500);
function CancelModal(props) {
    const { onClose, bookingId } = props;
    const { cancelBookingCopy, cancelBookingTitle } = useContext(OptionsCTX);
    const dispatch = useAppDispatch();
    const [error, setError] = useState(null);
    const stopProp = (ev) => {
        ev.stopImmediatePropagation();
    };
    const handleCancel = (id) => {
        cancelBooking(id)
            .then((res) => {
            const { activeBookings, pastBookings, message, success, } = res;
            if (success) {
                dispatch(setActiveBookings(activeBookings));
                dispatch(setPastBookings(pastBookings));
                onClose();
            }
            else if (message) {
                setError(message);
            }
        });
    };
    return (_jsx(Styles.Backdrop, { onClick: onClose, children: _jsxs(Styles.Inner, { onClick: stopProp, children: [_jsx(Styles.Close, { className: "close", type: "button", onClick: onClose, title: "Close Modal", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }), _jsxs(Wrapper, { children: [error && (_jsx(NoticeWrapper, { children: _jsx(FormNotices, { message: error, type: "error", handleClose: () => setError(null) }) })), _jsx(Title, { children: cancelBookingTitle }), _jsx(Copy, { children: cancelBookingCopy }), _jsxs(Actions, { children: [_jsx("button", { type: "button", className: "btn btn--outline-light", onClick: onClose, children: "Go Back" }), _jsx("button", { type: "button", className: "btn btn--primary", onClick: () => handleCancel(bookingId), children: "Cancel Booking" })] })] })] }) }));
}
export default CancelModal;
